import React, { useState, useEffect } from 'react';
import { Row, Col, Spin, Empty, Button, Space, message } from 'antd';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { mockPosts } from '../../api/mockData';
import PostCard from '../../components/PostCard';
import './index.css';

const Home = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadPosts();
  }, []);

  const loadPosts = () => {
    setTimeout(() => {
      // 从 localStorage 读取文章，如果没有则使用 mock 数据
      const savedPosts = JSON.parse(localStorage.getItem('blog_posts') || '[]');
      if (savedPosts.length > 0) {
        setPosts(savedPosts);
      } else {
        setPosts(mockPosts);
        // 初始化 localStorage
        localStorage.setItem('blog_posts', JSON.stringify(mockPosts));
      }
      setLoading(false);
    }, 500);
  };

  const handleAddNewPost = () => {
    navigate('/write');
  };

  const resetToExamples = () => {
    if (window.confirm('确定要重置文章库吗？这将用示例文章替换当前所有文章，且不可恢复。')) {
      localStorage.setItem('blog_posts', JSON.stringify(mockPosts));
      message.success('已成功重置为示例文章！');
      // 重新加载文章列表
      setPosts(mockPosts);
      // 显示提示信息
      message.info('现在显示的是示例文章。你可以点击"写文章"按钮开始创作！');
    }
  };

  const clearAllPosts = () => {
    if (window.confirm('确定要清空所有文章吗？此操作不可恢复！')) {
      localStorage.removeItem('blog_posts');
      setPosts([]);
      message.success('已清空所有文章！');
    }
  };

  if (loading) {
    return (
      <div className="home-loading">
        <Spin size="large" tip="加载中..." />
        <p style={{ marginTop: '20px', color: '#666' }}>正在加载文章...</p>
      </div>
    );
  }

  return (
    <div className="home-page">
      <div className="page-header">
        <div className="header-content">
          <h1>📝 My BlogShare</h1>
          <p className="subtitle">记录生活点滴，分享趣味见闻</p>
        </div>
        
        <div className="header-actions">
          <Space wrap>
            <Button 
              icon={<ReloadOutlined />} 
              onClick={resetToExamples}
              className="reset-btn"
            >
              重置
            </Button>
            {posts.length > 0 && (
              <Button 
                danger 
                onClick={clearAllPosts}
              >
                清空文章
              </Button>
            )}
            <Button 
              type="primary" 
              icon={<PlusOutlined />} 
              onClick={handleAddNewPost}
              className="add-post-btn"
            >
              写新文章
            </Button>
          </Space>
        </div>
      </div>

      <div className="stats-bar">
        <Space size="large">
          <span className="stat-item">
            <span className="stat-label">文章总数：</span>
            <span className="stat-value">{posts.length}</span>
          </span>
          <span className="stat-item">
            <span className="stat-label">总浏览量：</span>
            <span className="stat-value">
              {posts.reduce((sum, post) => sum + (post.views || 0), 0)}
            </span>
          </span>
          <span className="stat-item">
            <span className="stat-label">总点赞数：</span>
            <span className="stat-value">
              {posts.reduce((sum, post) => sum + (post.likes || 0), 0)}
            </span>
          </span>
        </Space>
      </div>
      
      {posts.length === 0 ? (
        <div className="no-posts">
          <Empty 
            description={
              <>
                <h3>还没有文章呢</h3>
                <p>开始你的创作之旅吧！</p>
              </>
            }
            imageStyle={{ height: 120 }}
          />
          <Space size="middle" style={{ marginTop: '30px' }}>
            <Button 
              type="primary" 
              size="large" 
              icon={<PlusOutlined />}
              onClick={handleAddNewPost}
            >
              开始写文章
            </Button>
            <Button 
              size="large" 
              icon={<ReloadOutlined />}
              onClick={resetToExamples}
            >
              加载示例文章
            </Button>
          </Space>
        </div>
      ) : (
        <>
          <div className="posts-section">
            <h2 className="section-title">📚 最新文章</h2>
            <Row gutter={[24, 24]}>
              {posts.map(post => (
                <Col key={post.id} xs={24} sm={12} lg={8}>
                  <PostCard post={post} />
                </Col>
              ))}
            </Row>
          </div>
          
          <div className="quick-actions">
            <h3>快速操作</h3>
            <Space wrap>
              <Button onClick={() => navigate('/archive')}>查看归档</Button>
              <Button onClick={handleAddNewPost}>再写一篇</Button>
              <Button onClick={() => window.scrollTo(0, 0)}>回到顶部</Button>
            </Space>
          </div>
        </>
      )}
    </div>
  );
};

export default Home;